/* eslint-disable no-unused-expressions */
import React from "react";
import * as Icon from "react-feather";
import moment from "moment";
import createNewBookingEngine from "../views/commonComponents/createNewBookingEngine";

const resolveModuleNav = (url) => {
  if (!url) {
    return { type: "item", navLink: url };
  }

  // DB app-modules may store ${BOOKING_APP_URL} as a placeholder
  if (
    url.includes("${BOOKING_APP_URL}") ||
    url.includes("%7BBOOKING_APP_URL%7D")
  ) {
    if (process.env.REACT_APP_BOOKING_DETAILS_PAGE === "NEW") {
      return {
        type: "external-link",
        newTab: true,
        navLink: createNewBookingEngine({
          add: true,
          edit: false,
          reservationId: null,
          isHref: true,
        }),
      };
    }
    return { type: "item", navLink: "/bookings/create" };
  }

  if (url === "/monthly-report") {
    return {
      type: "item",
      navLink: `${url}?month=${moment().get("month")}&year=${moment().get("year")}`,
    };
  }

  if (url === "/guests-list") {
    return {
      type: "item",
      navLink: `${url}/${moment().format("YYYY-MM-DD")}`,
    };
  }

  // Dashboard moved to /dashboard; DB may still store legacy "/"
  if (url === "/") {
    return { type: "item", navLink: "/dashboard" };
  }

  // External links should be used as-is
  if (/^https?:\/\//i.test(url)) {
    return { type: "external-link", newTab: true, navLink: url };
  }

  return { type: "item", navLink: url };
};

const horizontalDynamicConfig = (allowedNavigations) => {
  let isMobile = window.innerWidth < 1200

  // `showInMenu` defaults to true (missing/undefined => true)
  const menuAllowedNavigations = (allowedNavigations || []).filter(
    (item) => item?.moduleId && item.moduleId.showInMenu !== false
  );

  let topMenus = new Set(menuAllowedNavigations.filter(item => item?.moduleId?.topModuleName).sort((x, y) => x?.moduleId?.topModuleId?.priority - y?.moduleId?.topModuleId?.priority).map((data) => data?.moduleId?.topModuleName));
  let parentMenus = new Set(
    menuAllowedNavigations.map((data) => data?.moduleId?.parentModuleName)
  );
  let arrayList = [];

  Array.from(topMenus).map((item) => {
    let subname = [];
    menuAllowedNavigations.map((sval) => {
      if (item === sval?.moduleId?.topModuleName) {
        subname.push({
          topName: item,
          subName: sval?.moduleId?.parentModuleName || sval?.moduleId?.name,
        });
      }
    });
    let test = [];
    subname.forEach((val) => {
      if (test.length > 0 && !test.includes(val.subName)) {
        test.push(val.subName);
      } else if (test.length === 0) {
        test.push(val.subName);
      }
    });
    arrayList.push({ TName: subname[0].topName, sName: test });
  });

  let array = [];
  arrayList.map((menu) => {
    let navChild = [];
    menu.sName.forEach((child) => {
      menuAllowedNavigations.forEach((childData) => {
        // Only include modules that belong to the current top module.
        if (
          childData?.moduleId?.topModuleName === menu.TName &&
          child === childData?.moduleId?.parentModuleName
        ) {
          let obj2 = [];
          Array.from(parentMenus).map((subVal) => {
            menuAllowedNavigations.map((subdata) => {
              if (
                subdata?.moduleId?.topModuleName === menu.TName &&
                child === subdata?.moduleId?.parentModuleName
              ) {
                const resolved = resolveModuleNav(subdata?.moduleId?.url);
                const navObj2 = {
                  id: subdata?.moduleId?._id,
                  title: subdata?.moduleId?.name,
                  type: resolved.type,
                  icon: <Icon.Circle size={10} />,
                  permissions: ["admin", "editor"],
                  navLink: resolved.navLink,
                  ...(resolved.newTab ? { newTab: true } : {}),
                }
                obj2.push(navObj2);
              }
            });
          });

          const navChildObj = {
            id: child,
            title: child,
            type: obj2?.length ? (isMobile ? "collapse" : "dropdown") : "item",
            icon: <Icon.Circle size={10} />,
            permissions: ["admin", "editor"],
            priority: childData?.moduleId?.parentModuleId?.priority,
          }
          if (obj2?.length) {
            navChildObj.children = [
              ...new Map(obj2.map((item) => [item.id, item])).values(),
            ];
          }

          navChild.push(navChildObj);
        } 
        if (
          childData?.moduleId?.topModuleName === menu.TName &&
          child === childData?.moduleId?.name
        ) {
          const resolved = resolveModuleNav(childData?.moduleId?.url);
          const navChildObj = {
            id: child,
            title: child,
            type: resolved.type,
            icon: <Icon.Circle size={10} />,
            permissions: ["admin", "editor"],
            navLink: resolved.navLink,
            ...(resolved.newTab ? { newTab: true } : {}),
            priority: childData?.moduleId?.parentModuleId?.priority,
          }

          navChild.push(navChildObj);
        }
      });
    });

    array.push({
      id: menu.TName,
      title: menu.TName,
      type: isMobile ? "collapse" : "dropdown",
      icon: <Icon.Settings size={16} />,
      // Try to keep top-level menus ordered by TopModule priority
      priority:
        menuAllowedNavigations.find((x) => x?.moduleId?.topModuleName === menu.TName)?.moduleId
          ?.topModuleId?.priority ?? 9999,
      children: [
        ...new Map(navChild.map((item) => [item.title, item])).values(),
      ],
    });
  });

  // App-modules without a Top Module should show as individual top-level items.
  const ungrouped = menuAllowedNavigations
    .filter((item) => !item?.moduleId?.topModuleName)
    .map((item) => {
      const resolved = resolveModuleNav(item?.moduleId?.url);
      return {
        id: item?.moduleId?._id,
        title: item?.moduleId?.name,
        type: resolved.type,
        icon: <Icon.Settings size={16} />,
        permissions: ["admin", "editor"],
        navLink: resolved.navLink,
        ...(resolved.newTab ? { newTab: true } : {}),
        priority:
          typeof item?.moduleId?.menuPriority === "number"
            ? item.moduleId.menuPriority
            : item?.moduleId?.parentModuleId?.priority,
      };
    });

  const dedupedUngrouped = [
    ...new Map(ungrouped.filter((x) => x?.id).map((x) => [x.id, x])).values(),
  ].sort((a, b) => (a?.priority ?? 9999) - (b?.priority ?? 9999));

  array.push(...dedupedUngrouped);
  // Ensure consistent top-level ordering (ungrouped last by default priority)
  return array.sort((a, b) => (a?.priority ?? 9999) - (b?.priority ?? 9999));
};

export default horizontalDynamicConfig;
